"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.getConnectedEvents = void 0;
const constants_1 = require("../constants");
function getConnectedEvents(groupId, params = {}) {
    return {
        data: params,
        method: 'POST',
        url: `/${constants_1.serverlessBaseURL}/group/${groupId}/events/get-connected-events`,
    };
}
exports.getConnectedEvents = getConnectedEvents;
function update(params) {
    return {
        data: params,
        method: 'PATCH',
        url: `/${constants_1.serverlessBaseURL}/group/members-event/update`,
    };
}
exports.update = update;
//# sourceMappingURL=http.js.map